import { aboutImg } from "@/mocks/blcomics";

const values = [
  {
    icon: "ri-eye-line",
    title: "以画风为尺",
    desc: "我们坚持把「作画是否精美细腻」作为收录作品的核心标准，帮你看懂画面背后的功夫。",
  },
  {
    icon: "ri-palette-line",
    title: "精选而非堆砌",
    desc: "拒绝海量无效信息，只收录画风有辨识度、情感表达动人的优质 BL 漫画作品。",
  },
  {
    icon: "ri-heart-3-line",
    title: "认真陪伴",
    desc: "持续更新画风推荐与科普，让每一位读者都能找到最打动自己的那一抹笔触。",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">关于漫屿</p>
            <h2 className="mt-2 font-heading text-2xl text-foreground-900 md:text-4xl">一个专注 BL 漫画画风的精选站</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              「漫屿」诞生于对精美作画的喜爱。我们相信，好的 BL 漫画不止要有动人的故事，还要有与之相配的画风。
              于是我们按画风梳理作品，用标签和筛选让「作画好看、画风细腻」变得一目了然。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论你偏爱水彩晕染的温柔、水墨国风的悠远，还是厚涂光影的张力，都能在这里找到归属。
            </p>

            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${v.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-900">{v.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-6 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <a href="mailto:hi@manyu.example" className="flex items-center gap-2 text-sm text-foreground-700 transition hover:text-primary-600">
                <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
                hi@manyu.example
              </a>
              <span className="text-sm text-foreground-600">任何画风推荐建议，欢迎来信告诉我们</span>
            </div>
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-lg">
              <img src={aboutImg} alt="漫画画风精选工作室" className="aspect-[3/2] w-full object-cover object-top" />
            </div>
            <div className="mt-4 grid grid-cols-3 gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-center">
              {[
                { num: "8", label: "精选画风" },
                { num: "15+", label: "收录作品" },
                { num: "持续更新", label: "画风推荐" },
              ].map((s) => (
                <div key={s.label}>
                  <p className="font-heading text-xl text-primary-600 md:text-2xl">{s.num}</p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}